module.exports = __webpack_public_path__ + "img/unsuccessrocket.8a9a2c40.svg";